import React, { useCallback, useState } from 'react';

import { Link } from '@material-ui/core'

import makePath from '../../utils/makePath';
import { basicRTEControls, iconSetOptions } from '../../config/allInteractives';

import { Select, TextInput, RichTextEditor } from '../EditorFormElements';
import { Collapsible } from '../Global';

// Sections are small text blocks on Details (the "Learn More" subpage of a Progression). They have a title with an icon and a rich text field
export const Section = React.memo(({given = {}, index, ...props}) => { 
  const [label,setLabel] = useState( given.title ? given.title : `Subsection ${index + 1}`)
  const path = makePath(props.path,index);

  const callback = useCallback((name,value) => setLabel(value), [setLabel]);


  return (
    <Collapsible headerTag="h6" sortableChild title={label}>
  
      {/* Title */}
      <RichTextEditor
        name="title"
        label="Title"
        defaultValue={`Subsection ${index + 1}`}
        given={given.title}
        path={path}
        inlineToolbarControls={false}
        controls={['bold']}
        callback={callback}
      />

      {/* Icon Name */}
      <TextInput
        name="icon"
        label="Icon Name"
        defaultText="star"
        path={path}
        help={<span>Browse available icons on the Font Awesome Cheatsheet website. Copy and paste the icon’s name into the field (e.g. star). The icon will display within the interactive. <Link href="//fontawesome.com/cheatsheet" target="_blank" rel="noopener noreferrer">Browse Icons</Link></span>}
        given={given.icon}
        validationCriteria={{
          optional:false,
          mustChange: false,
        }}
      />

      {/* Icon Set */}
      <Select
        label="Icon Set"
        name='iconSet'
        path={path}
        options={iconSetOptions}
        given={given.iconSet}
      />


      {/* Rich Text */}
      <RichTextEditor
        name="richText"
        // label="Rich Text"
        path={path}
        given={given.richText}
        controls={basicRTEControls}
        defaultValue="Enter body text"
      />

      {props.deleteBtn}

    </Collapsible>
  )
})
  
